// extracted by mini-css-extract-plugin
export default {"star":"_3OO5-_jr7-8acw-DcDnChb","activeStar":"_32b5727ubV3wc9hWGtQ3Qw"};